// extracted by mini-css-extract-plugin
module.exports = {"loadingTransfer":"PosLookupField_loadingTransfer__3eoM4","loadingTransferSpinnerContainer":"PosLookupField_loadingTransferSpinnerContainer__KHGQF"};